import AdminPreferredNurseTable from 'components/AdminPreferredNurseTable'
import AdminNurseDetailContext from 'pages/AdminNurseDetail/context'
import React from 'react'

const AdminNursePreferredNurses: React.FC = () => {
  const {
    preferredNursesSearchForm,
    preferredNursesSelection,
    preferredNursesColumnVisibilityModel,
    preferredNursesSortModel,
    updatePreferredNursesSearchForm,
    setPreferredNursesSelection,
    setPreferredNursesColumnVisibilityModel,
    setPreferredNursesSortModel,
  } = React.useContext(AdminNurseDetailContext)
  
  return (
    <AdminPreferredNurseTable
      form={preferredNursesSearchForm}
      updateForm={updatePreferredNursesSearchForm}
      selection={preferredNursesSelection}
      setSelection={setPreferredNursesSelection}
      columnVisibilityModel={preferredNursesColumnVisibilityModel}
      setColumnVisibilityModel={setPreferredNursesColumnVisibilityModel}
      sortModel={preferredNursesSortModel}
      setSortModel={setPreferredNursesSortModel}
    />
  )
}

export default AdminNursePreferredNurses